<div [formGroup]="form" class="w-full">
    <!-- ===== Misure S1–S8 ===== -->
    <div class="misure-section">
        <div class="misure-section-title">Misure (S1–S8)</div>
        <div class="misure-grid">
            <div *ngFor="let s of sKeysSemplici" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ s.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[s] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + s" class="misura-input" [ngClass]="getInputRangeClass(s)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(s)" [ngClass]="getTrendIcon(s)"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== Quote A–D ===== -->
    <div class="misure-section">
        <div class="misure-section-title">Quote (A–D)</div>
        <div class="misure-grid">
            <div *ngFor="let x of ['a', 'b', 'c', 'd']" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ x.toUpperCase() }}</span>
                    <span class="misura-ref">{{ normativa?.['op' + x.toUpperCase()] }} {{ normativa?.[x] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + x" class="misura-input" [ngClass]="getRuleClass(x)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(x)" [ngClass]="getTrendIcon(x)"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== Quote P–Q ===== -->
    <div class="misure-section">
        <div class="misure-section-title">Quote (P–Q)</div>
        <div class="misure-grid">
            <div *ngFor="let pq of ['p', 'q']" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ pq.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[pq] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + pq" class="misura-input" [ngClass]="getRuleClass(pq)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(pq)" [ngClass]="getTrendIcon(pq)"></i>
                </div>
            </div>
        </div>
    </div>
</div>
